import { render, staticRenderFns } from "./_home.vue?vue&type=template&id=650b4b77&"
import script from "./_home.vue?vue&type=script&lang=js&"
export * from "./_home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports